"use strict";
/**
 * Signing out and deleting the account of a portal person
 * (tsk-appdata-self-delete). The platform offers the capability only: an App
 * brings its own button, confirmation and words. Both run on a page of the
 * platform at the top of the window, as the sign-in does, so they work on the
 * own address of an App Container and on a shared one alike; the page hands
 * the result back in the fragment of the page it returns to.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PORTAL_ACCOUNT_RESULT_KEY = exports.PORTAL_ACCOUNT_PAGE_ACTIONS = void 0;
exports.takePortalAccountResult = takePortalAccountResult;
/** The account page names its action in `?action=`. */
exports.PORTAL_ACCOUNT_PAGE_ACTIONS = {
    signOut: 'sign-out',
    deleteAccount: 'delete',
};
/** The key of the result in the fragment: `#sl-portal=<result>`. */
exports.PORTAL_ACCOUNT_RESULT_KEY = 'sl-portal';
/**
 * Takes the result of the account page from the address of the page, once:
 * reads `#sl-portal=<result>` (PORTAL_ACCOUNT_RESULT_KEY), removes it from the
 * address and returns it when it is a result of the contract, else null;
 * anything else in the fragment stays. The Bridges of the platform and of the
 * StreamKit inline it with toString(), so it uses nothing outside itself.
 */
function takePortalAccountResult(win) {
    const hash = win.location.hash;
    if (!hash)
        return null;
    const fragment = new URLSearchParams(hash.slice(1));
    const raw = fragment.get('sl-portal');
    if (raw === null)
        return null;
    fragment.delete('sl-portal');
    const rest = fragment.toString();
    try {
        win.history.replaceState(win.history.state, '', win.location.pathname + win.location.search + (rest ? '#' + rest : ''));
    }
    catch {
        // An address the page may not change keeps the fragment; the result
        // is still read once.
    }
    let result;
    try {
        result = JSON.parse(raw);
    }
    catch {
        return null;
    }
    const states = {
        signOut: ['signedOut'],
        deleteAccount: ['removed', 'pending'],
    };
    const codes = ['PORTAL_SESSION_REQUIRED', 'PORTAL_REQUEST_FAILED'];
    const action = result?.['action'];
    if (action !== 'signOut' && action !== 'deleteAccount')
        return null;
    if (result?.['ok'] === true &&
        typeof result['state'] === 'string' &&
        states[action].includes(result['state']))
        return {
            action,
            ok: true,
            state: result['state'],
        };
    if (result?.['ok'] === false &&
        typeof result['code'] === 'string' &&
        codes.includes(result['code']))
        return { action, ok: false, code: result['code'] };
    return null;
}
